import { Box, Grid2 as Grid } from "@mui/material";
import { DotLegalBreadCrumbModel, DotLegalPageHeader, DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../localization/useTranslation";
import AiAdministrationTopBar from "./aiAdministrationTopBar/AiAdministrationTopBar";
import MonthlySpendingLimitBox from "./monthlySpendingLimitBox/MonthlySpendingLimitBox";
import AiInfoBox from "./aiInfoBox/AiInfoBox";
import WelcomeOfferBox from "./welcomeOfferBox/WelcomeOfferBox";
import UsageForCurrentMonthBox from "./usageForCurrentMonthBox/UsageForCurrentMonthBox";
import { useAiAdministrationConfiguration } from "./AiAdministration.hooks";
import { usePlanContext } from "../auth/planProvider/PlanProvider";

function AiAdministration() {
    const { translateString } = useTranslation();
    const { data, isLoading, refetch } = useAiAdministrationConfiguration();
    const { addonsFeatures } = usePlanContext();
    const breadCrumbs: Array<DotLegalBreadCrumbModel> = [{ name: translateString("aiAdministration") }];

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader breadCrumbs={breadCrumbs} />
            <AiAdministrationTopBar />

            <DotLegalPaper sx={{ marginTop: 2 }} backgroundColor="lightPurple">
                <Grid container spacing={3} alignItems="stretch">
                    <Grid size={{ lg: 12, xl: 6 }}>
                        <MonthlySpendingLimitBox
                            welcomeCreditEur={data?.welcomeCreditEur ?? 0}
                            hasWelcomeCreditBeenExhausted={data?.hasWelcomeCreditBeenExhausted ?? false}
                            monthlySpendingLimitEur={data?.monthlySpendingLimitEur ?? null}
                            currentMonthlySpendingEur={data?.currentMonthlySpendingEur ?? 0}
                            isLoading={isLoading}
                            onLimitSaved={refetch}
                        />
                    </Grid>
                    <Grid size={{ lg: 12, xl: 6 }}>
                        <AiInfoBox />
                    </Grid>
                    {(data?.showWelcomeBox || !addonsFeatures.aiFeatures || isLoading) && (
                        <Grid size={12}>
                            <WelcomeOfferBox
                                welcomeCreditEur={data?.welcomeCreditEur ?? 0}
                                breakdown={data?.welcomeCreditSpendingBreakdown ?? null}
                                isLoading={isLoading}
                            />
                        </Grid>
                    )}
                    {addonsFeatures.aiFeatures && (
                        <Grid size={12}>
                            <UsageForCurrentMonthBox
                                monthlySpendingLimitEur={data?.monthlySpendingLimitEur ?? null}
                                breakdown={data?.currentMonthlySpendingBreakdown ?? null}
                                isLoading={isLoading}
                                hasWelcomeCreditBeenExhausted={data?.hasWelcomeCreditBeenExhausted ?? false}
                            />
                        </Grid>
                    )}
                </Grid>
            </DotLegalPaper>
        </Box>
    );
}

export default AiAdministration;
